module.exports = __webpack_public_path__ + "img/6.46019dd8.jpeg";